import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import './PageTemplate.css';
import styles from './Contact.module.css';
import contactIllustration from '../assets/images/home-bg.jpg';
import cloudDecoration from '../assets/contact/cloud-decoration.png';

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <div className="page contact-page">
      <Header />
      <main className={styles.contactContent}>
        <section className={styles.contactHero}>
          <div className={styles.contactHeroContent}>
            <h1>{t('contact.title')}</h1>
            <p>{t('contact.description')}</p>
          </div>
          <img src={cloudDecoration} alt="" className={styles.cloudDecoration} />
        </section>

        <section className={styles.contactMain}>
          <div className={styles.contactFormContainer}>
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="name">{t('contact.form.name')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder={t('contact.form.namePlaceholder') as string}
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="email">{t('contact.form.email')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder={t('contact.form.emailPlaceholder') as string}
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="subject">{t('contact.form.subject')}</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder={t('contact.form.subjectPlaceholder') as string}
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="message">{t('contact.form.message')}</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder={t('contact.form.messagePlaceholder') as string}
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={6}
                  required
                />
              </div>

              <button type="submit" className={styles.submitButton}>
                {t('contact.form.send')}
              </button>
            </form>

            <div className={styles.contactIllustration}>
              <img src={contactIllustration} alt="Contact illustration" />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Contact;